module.exports = __webpack_public_path__ + "img/selected7-min.54fec909.png";